import { Breakdown } from "@xola/ui-kit";
import { DateFormat, formatDate, isOtherSellerPurchase } from "common";
import React from "react";
import {
    LineItem,
    PaymentLineItemStatus,
    PaymentLineItem as PaymentLineItemType,
    PaymentMethod,
    Purchase,
} from "types";
import { PaymentCardInfo } from "./PaymentCardInfo";
import { PaymentMethodInfo } from "./PaymentMethodInfo";
import { getColor } from "./utils";
import { getSeller } from "@/utils/getSeller";

export const PaymentLineItem = ({ lineItem, purchase }: { lineItem: LineItem; purchase: Purchase }) => {
    const paymentLineItem = lineItem as PaymentLineItemType;
    const paymentMethod = paymentLineItem.payment?.method;
    if (paymentMethod === PaymentMethod.LATER || paymentLineItem.status === PaymentLineItemStatus.FAILED) {
        // TODO: What about Pending & Processing?
        return null;
    }

    return (
        <Breakdown.Item
            value={Math.abs(lineItem.amount)}
            info={<PaymentCardInfo lineItem={lineItem} purchase={purchase} />}
            methodIcon={
                <PaymentMethodInfo
                    lineItem={lineItem}
                    isPartnerPurchase={isOtherSellerPurchase(purchase, getSeller().id)}
                />
            }
            secondary={lineItem.createdAt ? formatDate(lineItem.createdAt, DateFormat.DATE_SHORT) : null}
            color={getColor(lineItem)}
            classNames={{ info: "no-translate" }}
            data-testid="payment-line-item"
        >
            {lineItem.name}
        </Breakdown.Item>
    );
};
